export default __webpack_public_path__ + "static/media/LibertyInsurance.9eec5bd8.svg";